<main class="dialog" appCloseOnEscape>
  <div class="header" [ngClass]="data.type">
    <div class="head-text">
      <h4 class="title">{{ data.title }}</h4>
      <p class="subtitle" *ngIf="data.message">{{ data.message }}</p>
    </div>
  </div>

  <section class="changes" *ngIf="data.rows?.length; else empty">
    <div class="group" *ngFor="let g of data.rows">
      <div class="group-header">
        <div class="group-name">{{ g.name }}</div>
        <div class="group-summary">
          <span class="badge chip-info">
            {{ getGroupTotal(g) }} {{ getGroupLabel(g) }}
          </span>
        </div>
      </div>

      <div class="group-body">
        <div class="item" *ngFor="let it of g.items">
          <div class="item-left">
            <span class="item-kind" [ngClass]="kindClass(it.kind)">
              {{ getKindName(it.kind) }}
            </span>
          </div>
          <div class="item-right">
            <div class="item-total">{{ it.total }}</div>
            <div class="item-breakdown" *ngIf="it.breakdown">
              <span *ngFor="let key of getBreakdownKeys(it.breakdown); let last = last">
                <span class="sep">• </span>
                <label class="muted">{{ getObjectTypeLabel(key) }}: {{ it.breakdown[key] }}</label>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="group-link" *ngIf="g.name">
        <button class="btn-link" (click)="goToChanges(g)">
          {{ 'dialog.viewDetails' | transloco }}
          <span class="arrow">→</span>
        </button>
      </div>
    </div>
  </section>

  <ng-template #empty>
    <p class="no-changes">{{ 'dialog.noChanges' | transloco }}</p>
  </ng-template>

  <div class="actions">
    <ng-container *ngIf="data.confirm; else singleBtn">
      <button class="btn ghost" (click)="onClose(false)">{{ 'dialog.no' | transloco }}</button>
      <button class="btn primary" (click)="onClose(true)">{{ 'dialog.yes' | transloco }}</button>
    </ng-container>
    <ng-template #singleBtn>
      <button class="btn primary" (click)="onClose()">{{ 'dialog.ok' | transloco }}</button>
    </ng-template>
  </div>
</main>
